'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HAVE_METADATA = 1;

var isFullScreenRequested = false;

var IOSFullScreen = function () {
  function IOSFullScreen(elem, callback) {
    _classCallCheck(this, IOSFullScreen);

    this._elem = elem;
    this._callback = callback;

    this._bindEvents();
  }

  _createClass(IOSFullScreen, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this._elem.addEventListener('webkitbeginfullscreen', this._callback);
      this._elem.addEventListener('webkitendfullscreen', this._callback);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._elem.removeEventListener('webkitbeginfullscreen', this._callback);
      this._elem.removeEventListener('webkitendfullscreen', this._callback);

      this._elem.removeEventListener('loadedmetadata', this._enterWhenHasMetaData);
    }
  }, {
    key: '_enterWhenHasMetaData',
    value: function _enterWhenHasMetaData() {
      this._elem.removeEventListener('loadedmetadata', this._enterWhenHasMetaData);

      isFullScreenRequested = false;

      this._elem.webkitEnterFullscreen();
    }
  }, {
    key: 'request',
    value: function request() {
      if (!this.isEnabled || this.isInFullScreen) {
        return false;
      }

      try {
        this._elem.webkitEnterFullscreen();
      } catch (e) {
        if (this._elem.readyState < HAVE_METADATA) {
          if (isFullScreenRequested) {
            return;
          }
          this._elem.addEventListener('loadedmetadata', this._enterWhenHasMetaData);
          isFullScreenRequested = true;
        }
      }
    }
  }, {
    key: 'exit',
    value: function exit() {
      if (!this.isAPIExist || !this.isInFullScreen) {
        return false;
      }

      this._elem.webkitExitFullscreen();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      delete this._elem;
      delete this._callback;
    }
  }, {
    key: 'isAPIExist',
    get: function get() {
      return Boolean(this._elem && this._elem.webkitSupportsFullscreen);
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return Boolean(this._elem && this._elem.webkitDisplayingFullscreen);
    }
  }, {
    key: 'isEnabled',
    get: function get() {
      return this.isAPIExist;
    }
  }]);

  return IOSFullScreen;
}();

exports.default = IOSFullScreen;
//# sourceMappingURL=ios.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/full-screen/ios.js
// module id = 1693
// module chunks = 1 2 3